import React from 'react';

function AfternoonIcon() {
  return (
    <svg id="noun_sun_4020588" xmlns="http://www.w3.org/2000/svg" width="429.811" height="429.811" viewBox="0 0 429.811 429.811">
      <path
        id="Path_3931"
        data-name="Path 3931"
        d="M147.507,26.61h0a120.9,120.9,0,0,0-120.9,120.9h0a120.9,120.9,0,0,0,120.9,120.9h0a120.9,120.9,0,0,0,120.9-120.9h0A120.9,120.9,0,0,0,147.507,26.61Z"
        transform="translate(67.399 67.399)"
        fill="#717171"
      />
      <path
        id="Path_3932"
        data-name="Path 3932"
        d="M59.225,82.082A11.44,11.44,0,0,0,70.664,70.643V19.86a11.438,11.438,0,0,0-22.877,0V70.643A11.44,11.44,0,0,0,59.225,82.082Z"
        transform="translate(155.68 -8.422)"
        fill="#717171"
      />
      <path
        id="Path_3933"
        data-name="Path 3933"
        d="M59.225,77.327A11.44,11.44,0,0,0,47.787,88.765v50.783a11.438,11.438,0,0,0,22.877,0V88.765A11.44,11.44,0,0,0,59.225,77.327Z"
        transform="translate(155.68 278.824)"
        fill="#717171"
      />
      <path
        id="Path_3934"
        data-name="Path 3934"
        d="M55.028,74.826A11.435,11.435,0,0,0,74.834,63.393L49.445,19.418A11.435,11.435,0,1,0,29.639,30.851Z"
        transform="translate(73.632 13.569)"
        fill="#717171"
      />
      <path
        id="Path_3935"
        data-name="Path 3935"
        d="M83.9,79.09A11.435,11.435,0,0,0,68.278,74.9h0a11.435,11.435,0,0,0-4.187,15.62L89.48,134.5a11.435,11.435,0,1,0,19.807-11.433Z"
        transform="translate(217.253 262.325)"
        fill="#717171"
      />
      <path
        id="Path_3936"
        data-name="Path 3936"
        d="M19.417,49.446,63.392,74.834A11.435,11.435,0,0,0,74.825,55.028L30.85,29.639A11.435,11.435,0,1,0,19.417,49.446Z"
        transform="translate(13.565 73.632)"
        fill="#717171"
      />
      <path
        id="Path_3937"
        data-name="Path 3937"
        d="M134.5,89.48,90.524,64.091A11.435,11.435,0,1,0,79.091,83.9l43.976,25.389a11.435,11.435,0,0,0,15.62-4.187h0A11.435,11.435,0,0,0,134.5,89.48Z"
        transform="translate(262.33 217.253)"
        fill="#717171"
      />
      <path
        id="Path_3938"
        data-name="Path 3938"
        d="M82.082,59.225A11.44,11.44,0,0,0,70.643,47.787H19.86a11.438,11.438,0,0,0,0,22.877H70.643A11.44,11.44,0,0,0,82.082,59.225Z"
        transform="translate(-8.422 155.68)"
        fill="#717171"
      />
      <path
        id="Path_3939"
        data-name="Path 3939"
        d="M139.548,47.788H88.765a11.438,11.438,0,0,0,0,22.877h50.783a11.438,11.438,0,0,0,0-22.877Z"
        transform="translate(278.824 155.684)"
        fill="#717171"
      />
      <path
        id="Path_3940"
        data-name="Path 3940"
        d="M63.392,64.092,19.417,89.481A11.435,11.435,0,0,0,15.23,105.1h0a11.435,11.435,0,0,0,15.62,4.187L74.825,83.9A11.435,11.435,0,1,0,63.392,64.092Z"
        transform="translate(13.565 217.252)"
        fill="#717171"
      />
      <path
        id="Path_3941"
        data-name="Path 3941"
        d="M90.524,74.834,134.5,49.445a11.435,11.435,0,0,0-11.434-19.807L79.091,55.028A11.435,11.435,0,1,0,90.524,74.834Z"
        transform="translate(262.33 73.632)"
        fill="#717171"
      />
      <path
        id="Path_3942"
        data-name="Path 3942"
        d="M70.648,74.9a11.435,11.435,0,0,0-15.62,4.187L29.639,123.065A11.435,11.435,0,1,0,49.446,134.5L74.834,90.523A11.431,11.431,0,0,0,70.648,74.9Z"
        transform="translate(73.632 262.325)"
        fill="#717171"
      />
      <path
        id="Path_3943"
        data-name="Path 3943"
        d="M68.279,79.013h0A11.435,11.435,0,0,0,83.9,74.826l25.389-43.976A11.435,11.435,0,1,0,89.481,19.418L64.092,63.393A11.431,11.431,0,0,0,68.279,79.013Z"
        transform="translate(217.252 13.569)"
        fill="#717171"
      />
    </svg>
  );
}

export default AfternoonIcon;
